import { forwardRef, Ref, useEffect, useImperativeHandle, useMemo, useState } from "react"
import { onChange } from "../../../../../../../../../utils/types"
import { ResendActivityProps, ResendActivityRef } from "./types"
import { useTranslation } from "react-i18next"
import { Box, Grid, InputAdornment, Pagination, Typography } from "@mui/material"
import { FooterSimple } from "../../../../../../../../../components/buttons/footer"
import { BaseInput } from "../../../../../../../../../components"
import { icons } from "../../../../../../../../../utils/icons"
import { isEmailSeparateToCome } from "../../../../../../../../../utils/validate/validate"
import { useTimeOut } from "../../../../../../../../../hooks/timeOut"
import { loogbookServiceFetch } from "../../../../../../../../../utils/constants/callService"
import { useStyles } from "./styles"
import { NoResponse } from "../../../../../../../../../components/errors/noResponse"
import { ScrollContainer } from "../../../../../../../../../components/scrollContainer"
import { FormProvider, useForm } from "react-hook-form"
import { ItemsUser } from "./item"
import Loader from "../../../../../../../../../components/loader"

const itemsAmount = 16
export const ResendActivity = forwardRef(({ cancel, confirm, }: ResendActivityProps, ref: Ref<ResendActivityRef>) => {
    const { t } = useTranslation()
    const methods = useForm<{ selectedIds: string[] }>({
        defaultValues: { selectedIds: [] }
    });
    const selectedIds = methods.watch('selectedIds');
    const styles = useStyles()
    const [totalPages, setTotalPages]=useState(0)
    const [currentPage, setCurrentPage]=useState(0)
    const { executeFunction } = useTimeOut()
    const [page, setPage] = useState(0)
    const [userList, setUserList] = useState<{ fullName: string; id: number | string }[]>([])
    const [loading, setLoading] = useState({
        submit: false, list: false
    })
    /* const users = useMemo(() => {
        const list = userList?.slice(
            page * itemsAmount,
            page * itemsAmount + itemsAmount)
        return list
    } , [page, userList]) */
    const [value, setValue] = useState({ input: { email: { value: '', label: '', }, search: { value: '', label: '', } }, })
    const disabledResend = useMemo(() => {
        const email = value?.input?.email?.value
        const emailIsSeparate = !(isEmailSeparateToCome(email))
        return (!email || emailIsSeparate) && !selectedIds?.length
    }, [value?.input?.email?.value, selectedIds])
    const onChange: onChange = ({ target }) => {
        const { name, value } = target
        setValue((prev) => ({
            ...prev,
            input: {
                ...prev.input,
                [name as 'email' | 'search']: {
                    ...prev.input[name as 'email' | 'search'],
                    value,
                },
            },
        }))
    }
    const searchUsers = async () => {
        const search = value?.input?.search?.value
        const response = await loogbookServiceFetch.getUsersData({ query: search ? `search=${search}&page=${page+1}&size=${itemsAmount}` : `page=${page+1}&size=${itemsAmount}` })
        setUserList(response?.items?.map(user => ({ fullName: `${user.firstName} ${user.lastName}`, id: user.id ?? '' })))
        setTotalPages(response.totalPages)
        setCurrentPage(response.currentPage)
        setLoading((prev) => ({ ...prev, list: false }))
    }
    const handleChangePage = (_: unknown, pageChange: number) => {
        setPage(pageChange - 1)
    }
    const checkAll = ({ all }: { all: boolean }) => {
        methods.reset({ selectedIds: all ? userList.map(user => user.id.toString()) : userList.filter(user => !selectedIds.some(userId => userId == user.id)).map(user => user.id.toString()) }, { keepDirty: false })
    }
    useEffect(() => {
        setLoading((prev) => ({ ...prev, list: true }))
        executeFunction({ execute: searchUsers })
    }, [value?.input?.search?.value,page])
    useImperativeHandle(ref, () => ({
        getData: {
            usersIds: selectedIds,
            emails: value?.input?.email?.value ?? ''
        },
        loading: (value) => { setLoading((prev) => ({ ...prev, submit: value })) }
    }))
    return (
        <Box sx={styles.container}>
            <Typography variant="subtitle_grey" fontWeight='bold'>{t('general.externalUsers')}</Typography>

            <BaseInput
                fullWidth
                sx={{ width: '100%' }}
                name="email"
                placeholder={t('general.exampleEmail')}
                onChange={onChange}
                value={value.input}
            />

            <Typography variant="subtitle_grey" fontWeight='bold'>{t('general.internalUsers')}</Typography>

            <BaseInput
                fullWidth
                sx={{ width: '100%' }}
                name="search"
                placeholder={t('general.search')}
                label={t('general.search')}
                onChange={onChange}
                value={value.input}
                type="alphaNumeric"
                InputProps={{
                    endAdornment: <InputAdornment position="end">{icons('search')}</InputAdornment>,
                }}
            />
            {!!loading.list && <Loader />}
            {!userList?.length && !loading.list && (<NoResponse label="No se encontraron usuarios" />)}
            {
                !!userList?.length && !loading.list && (
                    <>
                        <FooterSimple
                            container={{ sx: styles.btn }}
                            cancel={{
                                variant: 'text',
                                children: t('general.addTruechecket'),
                                onClick: () => { checkAll({ all: true }) }
                            }}
                            confirm={{
                                variant: 'text',
                                children: t('general.addFalsechecket'),
                                onClick: () => { checkAll({ all: false }) }
                            }}
                        />
                        <FormProvider {...methods}>
                            <ScrollContainer maxHeight="250px" sx={styles.listContainer}>
                                <Grid container spacing={1}>
                                    {userList?.map((user) => (<ItemsUser key={user.id} isCheck={selectedIds.some(userId => userId == user.id)} user={user} />))}
                                </Grid>
                            </ScrollContainer>
                        </FormProvider>

                        <Pagination
                            sx={styles.pagination}
                            count={totalPages}
                            page={currentPage}
                            onChange={handleChangePage}
                            showFirstButton
                            showLastButton
                        />
                    </>
                )
            }
            <FooterSimple
                cancel={{
                    children: t('general.cancel'),
                    onClick: cancel
                }}
                confirm={{
                    children: t('general.resend'),
                    loading: loading.submit,
                    disabled: !!disabledResend,
                    onClick: confirm,
                    variant: 'primary_c'
                }}
            />
        </Box >
    )
})